import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "userContainer",
  style: {"background-color":"white"}
}
const _hoisted_2 = {
  class: "bj",
  style: {"margin":"30px 50px","height":"200px"}
}
const _hoisted_3 = { style: {"width":"58%","font-size":"32px","color":"#6692C5","background-color":"white","text-indent":"2em"} }
const _hoisted_4 = { style: {"width":"58%","font-size":"32px","color":"#6692C5","background-color":"white","text-indent":"2em"} }
const _hoisted_5 = {
  class: "zebra",
  style: {"width":"100%"}
}
const _hoisted_6 = {
  colspan: "6",
  style: {"height":"10px","overflow":"hidden","background-color":"white"}
}
const _hoisted_7 = {
  class: "bxsliderNew width100",
  id: "table1",
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  style: {"width":"30%"},
  class: "td11"
}
const _hoisted_10 = {
  style: {"width":"10%"},
  class: "td12"
}
const _hoisted_11 = {
  style: {"width":"20%"},
  class: "td13"
}
const _hoisted_12 = {
  style: {"width":"20%"},
  class: "td14"
}

import {onBeforeMount, ref} from 'vue';
import {oneCodeIntegrationList} from "@/config/request";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const list = ref([]) as any;
const applyname = ref();
const applyCardnumber = ref();
const projid = router.currentRoute.value.query.projid;
let param = {
    projid:projid
}
onBeforeMount(async () => {
    const res = await oneCodeIntegrationList(param) as any
    if (res.code == 200) {
    list.value = res.result;
    console.log(list.value)
    applyname.value = res.result[0].applyname;
    applyCardnumber.value = res.result[0].applyCardnumber;
}
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"row\"><div class=\"col-xs-12\" style=\"height:200px;background-color:#1265B3;color:white;\"><div class=\"row\"><div class=\"col-xs-12\" style=\"text-align:center;\"><span style=\"font-size:40px;font-weight:bolder;height:100px;display:block;vertical-align:middle;left:-80px;top:50px;position:relative;\">中国（河南）自由贸易试验区开封片区</span><br> <br><br><span style=\"font-size:30px;font-weight:bolder;display:block;vertical-align:middle;left:-80px;top:-50px;position:relative;\">一码集成信息</span></div></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"margin-top":"0%"} }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("label", { class: "label" }, "企业名称：", -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(applyname.value), 1),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label" }, "社会信用代码：", -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(applyCardnumber.value), 1)
      ]),
      _createElementVNode("table", _hoisted_5, [
        _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
          _createElementVNode("tr", { style: {"background-color":"#1265B3","height":"50px","line-height":"50px"} }, [
            _createElementVNode("th", { style: {"width":"30%","font-size":"20px","color":"white"} }, "办理业务"),
            _createElementVNode("th", { style: {"width":"10%","font-size":"20px","color":"white"} }, "办理状态"),
            _createElementVNode("th", { style: {"width":"20%","font-size":"20px","color":"white"} }, "证照批复"),
            _createElementVNode("th", { style: {"width":"20%","font-size":"20px","color":"white"} }, "获取时间")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                (list.value.length > 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          style: {"background-color":"#e8e8e8","height":"50px","line-height":"50px"},
                          key: index
                        }, [
                          _createElementVNode("td", _hoisted_9, _toDisplayString(item.servicename), 1),
                          _createElementVNode("td", _hoisted_10, _toDisplayString(item.handlestate), 1),
                          _createElementVNode("td", _hoisted_11, _toDisplayString(item.licenseName), 1),
                          _createElementVNode("td", _hoisted_12, _toDisplayString(item.issueDate), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "footer",
        style: {"width":"96%","margin-bottom":"0%","background-color":"white"}
      }, [
        _createElementVNode("p", null, [
          _createElementVNode("span", { style: {"font-size":"26px","height":"30px","display":"block"} }, "中国（河南）自由贸易试验区开封片区"),
          _createElementVNode("br"),
          _createElementVNode("span", { style: {"font-size":"26px"} }, "技术支持:深圳太极云软技术有限股份公司"),
          _createElementVNode("br")
        ])
      ], -1))
    ])
  ], 64))
}
}

})